import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgDiscountTag = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 17.955C2 19.084 2.957 20 4.14 20h15.72c1.183 0 2.14-.916 2.14-2.046v-2.773a.66.66 0 0 0-.147-.415.7.7 0 0 0-.38-.244 2.2 2.2 0 0 1-1.168-.75 2.03 2.03 0 0 1-.451-1.272c0-.46.159-.907.451-1.273a2.2 2.2 0 0 1 1.168-.75.7.7 0 0 0 .38-.243.66.66 0 0 0 .147-.415V7.045C22 5.916 21.043 5 19.86 5H4.14C2.957 5 2 5.916 2 7.045v2.769c0 .15.053.296.149.416.096.119.231.204.384.242.47.117.886.38 1.182.747.297.367.458.818.458 1.281s-.16.914-.458 1.28c-.296.368-.712.63-1.182.748a.7.7 0 0 0-.384.242.66.66 0 0 0-.149.416zm7.089-1.443 7.142-6.818a.83.83 0 0 0 .244-.597.83.83 0 0 0-.261-.59.91.91 0 0 0-.618-.25.92.92 0 0 0-.626.231l-7.143 6.818a.82.82 0 0 0-.02 1.223.931.931 0 0 0 1.281-.017m-1.345-6.74c0-.36.15-.708.419-.964.268-.255.631-.399 1.01-.399s.742.144 1.01.4c.268.255.418.602.418.964 0 .361-.15.708-.418.964s-.631.4-1.01.4-.742-.144-1.01-.4a1.33 1.33 0 0 1-.419-.964m5.715 5.455c0-.361.15-.708.418-.964s.631-.4 1.01-.4.742.144 1.01.4.419.603.419.964c0 .362-.15.709-.419.965-.268.255-.631.399-1.01.399s-.742-.144-1.01-.4a1.33 1.33 0 0 1-.418-.964"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgDiscountTag;
